import { Competition, CompetitionAPI, API } from "@brg/api";
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { getCurrentContextName } from "supporting";

/**
 * Данный хук используется в связке с компонентом <Pagination />
 *
 * @param id ID проекта
 * @param pageType строковый параметр типа страницы, например "competition"
 * @param [disabled] отключает работу хука
 */
const useDocumentTitle = (id: string | undefined, pageType: string | undefined, disabled?: boolean) => {
    const [title, setTitle] = useState<string>();
    const { i18n: { language } } = useTranslation();

    const fetchTitle = (type: string, id: string) => {
        switch (type) {
            case "competition":
                return CompetitionAPI.Get({ idCompetition: id })
                .then(d => d.json())
                .then(r => API.toLang<Competition>( r, language ))
                .then(r => r && r.name && setTitle(r?.name));
            default:
                return false;
        }
    }

    useEffect(() => {
        if (id && pageType && !disabled) {
            fetchTitle(pageType, id);
        }
    }, [id, pageType, disabled])

    useEffect(() => {
        if(disabled) return;

        const titleTag = document.querySelector("head title");

        if (title && titleTag) {
                titleTag.textContent = title;
                return () => {
                    titleTag.textContent = getCurrentContextName().toUpperCase()
                }
        }
    }, [title, disabled])

}

export default useDocumentTitle;import { Competition, CompetitionAPI, API } from "@brg/api";
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { getCurrentContextName } from "supporting";

/**
 * Данный хук используется в связке с компонентом <Pagination />
 *
 * @param id ID проекта
 * @param pageType строковый параметр типа страницы, например "competition"
 * @param [disabled] отключает работу хука
 */
const useDocumentTitle = (id: string | undefined, pageType: string | undefined, disabled?: boolean) => {
    const [title, setTitle] = useState<string>();
    const { i18n: { language } } = useTranslation();

    const fetchTitle = (type: string, id: string) => {
        switch (type) {
            case "competition":
                return CompetitionAPI.Get({ idCompetition: id })
                .then(d => d.json())
                .then(r => API.toLang<Competition>( r, language ))
                .then(r => r && r.name && setTitle(r?.name));
            default:
                return false;
        }
    }

    useEffect(() => {
        if (id && pageType && !disabled) {
            fetchTitle(pageType, id);
        }
    }, [id, pageType, disabled])

    useEffect(() => {
        if(disabled) return;

        const titleTag = document.querySelector("head title");

        if (title && titleTag) {
                titleTag.textContent = title;
                return () => {
                    titleTag.textContent = getCurrentContextName().toUpperCase()
                }
        }
    }, [title, disabled])

}

export default useDocumentTitle;